export default __webpack_public_path__ + "assets/SM-Slider_TrackBackground_hover.svg";